import { APIGatewayResponse } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { Nullable } from '@dxb-web-ui-framework/common/types';
import { AxiosError } from 'axios';
import { useContext, useContextSelector } from 'use-context-selector';
import { CheckMandateResponseBody } from '../../domain/Authorization/entities/CheckMandateResponseDTO';
import { ConsolidatedTransactionDetails } from '../../../../transaction/src/domain/Transaction/entities/ConsolidatedTransaction';
import { TransactionsWithDealerRateServiceBody } from '../../../../transaction/src/domain/Transaction/entities/TransactionWithDealerRate/TransactionWithDealerRateResponseDTO';
import { TransactionsContext } from './TransactionsContext';

const useTransactionsState = () => {
  const context = useContext(TransactionsContext);

  if (context === undefined) {
    throw new Error('useTransactionsState must be used within TransactionsProvider');
  }

  return context;
};

const useTransactionDetails = () => {
  const context = useContextSelector(TransactionsContext, state => state.transactionDetails);

  // if (context === undefined) {
  //   throw new Error('useTransactionDetails must be used within TransactionsProvider');
  // }

  return context;
};

const useTransactionsProviderLoadingState = (
  loadingProperty: 'isLoadingTransactionDetails' | 'isLoadingCheckAuthorization',
) => {
  const context = useContextSelector(TransactionsContext, state => state.loadingState[loadingProperty]);

  if (context === undefined) {
    throw new Error('useTransactionsProviderLoadingState must be used within TransactionsProvider');
  }

  return context;
};

const useTransactionsProviderActions = () => {
  const context = useContextSelector(TransactionsContext, state => state.actions);

  if (context === undefined) {
    throw new Error('useTransactionsProviderActions must be used within TransactionsProvider');
  }

  return context;
};

const useCheckAuthorization = () => useContextSelector(TransactionsContext, state => state.checkAuthorizationData);

const useOnCheckAuthorizationMutation = () => {
  const context = useContextSelector(TransactionsContext, state => state.onCheckAuthorizationMutation);

  if (context === undefined) {
    throw new Error('useOnCheckAuthorizationMutation must be used within ConsolidatedTransactionsProvider');
  }

  return context;
};

// @ts-ignore
const useTransactionsProviderErrorState = (
  errorProperty: 'transactionDetailsError' | 'checkAuthorizationError',
): Nullable<
  | AxiosError<APIGatewayResponse<TransactionsWithDealerRateServiceBody>, any>
  | AxiosError<APIGatewayResponse<ConsolidatedTransactionDetails>, any>
  | AxiosError<APIGatewayResponse<CheckMandateResponseBody>, any>
> => {
  const context = useContextSelector(TransactionsContext, state => state.errorState[errorProperty] ?? null);

  // if (context === undefined) {
  //   throw new Error(
  //     'useTransactionsProviderErrorState must be used within TransactionsProvider',
  //   );
  // }

  return context;
};

export {
  useOnCheckAuthorizationMutation,
  useCheckAuthorization,
  useTransactionsState,
  useTransactionsProviderActions,
  useTransactionDetails,
  useTransactionsProviderLoadingState,
  useTransactionsProviderErrorState,
};
